// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1___390f66e0994786951d6","cls2":"ToolsMenu-cls2___ed9181821f9a241b5ae ToolsMenu-cls1___390f66e0994786951d6"};